import { render, staticRenderFns } from "./info-items.vue?vue&type=template&id=436d1d78&scoped=true"
import script from "./info-items.vue?vue&type=script&lang=js"
export * from "./info-items.vue?vue&type=script&lang=js"
import style0 from "./info-items.vue?vue&type=style&index=0&id=436d1d78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d1d78",
  null
  
)

export default component.exports